import { ConcreteEncodable } from "./ConcreteEncodable";

import { StaticDataProfileImplEncoder } from "../../encoder/StaticDataProfileImplEncoder";

import * as CubiqTS from "../../index";
import { StaticDataProfile } from "../StaticDataProfile";

export class StaticDataProfileImpl extends ConcreteEncodable implements StaticDataProfile {
  public static enType: string = "com.bcdfx.model.StaticDataProfileImpl";

  /*FID=1*/
  public accounts: Array<CubiqTS.Account> | null = null;
  /*FID=2*/
  public allSalesGroups: Array<CubiqTS.SalesGroup> | null = null;
  /*FID=3*/
  public allTradingGroups: Array<CubiqTS.TradingGroup> | null = null;
  /*FID=4*/
  public clients: Array<CubiqTS.Client> | null = null;
  /*FID=5*/
  public currencyPairs: Array<CubiqTS.CurrencyPair> | null = null;
  /*FID=6*/
  public currencys: Array<CubiqTS.Currency> | null = null;
  /*FID=7*/
  public fixingSources: Array<CubiqTS.NdfSource> | null = null;
  /*FID=8*/
  public salesGroups: Array<CubiqTS.Long> | null = null;
  /*FID=9*/
  public slSlippageConstants: Array<string> | null = null;
  /*FID=10*/
  public tradingGroups: Array<CubiqTS.Long> | null = null;
  /*FID=11*/
  public user: CubiqTS.User | null = null;
  /*FID=12*/
  public updateMask: CubiqTS.Long | null = null;
  /*FID=13*/
  public blotterFilters: Array<CubiqTS.DataProfileDescriptor> | null = null;
  /*FID=14*/
  public profileSettings: Array<CubiqTS.ProfileSetting> | null = null;
  /*FID=15*/
  public systemSettings: Array<CubiqTS.SystemSetting> | null = null;
  /*FID=16*/
  public userRoles: Array<string> | null = null;
  /*FID=17*/
  public users: Array<CubiqTS.User> | null = null;
  /*FID=18*/
  public rateSources: Array<CubiqTS.RateSource> | null = null;
  /*FID=19*/
  public currencyPairGroups: Array<CubiqTS.CurrencyPairGroup> | null = null;
  /*FID=20*/
  public environmentTag: string;
  /*FID=21*/
  public tradingChannelProfiles: Array<CubiqTS.TradingChannelProfile> | null = null;
  /*FID=22*/
  public branches: Array<CubiqTS.Branch> | null = null;
  /*FID=23*/
  public defaultPositionBook: CubiqTS.PositionBook | null = null;
  /*FID=24*/
  public timeZones: Array<CubiqTS.TimeZone> | null = null;
  /*FID=25*/
  public marketTimeConstants: Array<CubiqTS.MarketTimeConstant> | null = null;
  /*FID=26*/
  public clientContacts: Array<CubiqTS.ClientContact> | null = null;
  /*FID=27*/
  public offlineSystemControls: Array<CubiqTS.SystemControl> | null = null;
  /*FID=28*/
  public userVisibilityProfile: CubiqTS.UserVisibilityProfile | null = null;
  /*FID=29*/
  public tradableClientCodes: Array<string> | null = null;
  /*FID=30*/
  public tradableAccountCodes: Array<string> | null = null;
  /*FID=31*/
  public algoStrategies: Array<CubiqTS.AlgoStrategy> | null = null;
  /*FID=32*/
  public systemVersion: string;
  /*FID=33*/
  public customFieldDefinitions: Array<CubiqTS.CustomField> | null = null;
  /*FID=34*/
  public benchmarkFixings: Array<CubiqTS.BenchmarkFixing> | null = null;
  /*FID=35*/
  public algoHedgeConfigInfos: Array<CubiqTS.AlgoHedgeConfigInfo> | null = null;
  /*FID=36*/
  public tradableBranches: Array<string> | null = null;
  /*FID=37*/
  public systemTradeDateRoll: CubiqTS.moment.Moment | null = null;
  /*FID=38*/
  public requestOrderTypeStrategies: Array<CubiqTS.PlRequestOrderTypeStrategy> | null = null;
  /*FID=39*/
  public tradableAlgos: Array<string> | null = null;
  /*FID=40*/
  public autoHedgingStatus: CubiqTS.AutoHedgingStatus | null = null;
  /*FID=41*/
  public platformProfiles: Array<CubiqTS.PlatformProfile> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StaticDataProfileImplEncoder.Instance;
    this.setEncodableType(StaticDataProfileImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StaticDataProfileImpl[" +
      "accounts=" +
      this.accounts +
      "allSalesGroups=" +
      this.allSalesGroups +
      "allTradingGroups=" +
      this.allTradingGroups +
      "clients=" +
      this.clients +
      "currencyPairs=" +
      this.currencyPairs +
      "currencys=" +
      this.currencys +
      "fixingSources=" +
      this.fixingSources +
      "salesGroups=" +
      this.salesGroups +
      "slSlippageConstants=" +
      this.slSlippageConstants +
      "tradingGroups=" +
      this.tradingGroups +
      "user=" +
      this.user +
      "updateMask=" +
      this.updateMask +
      "blotterFilters=" +
      this.blotterFilters +
      "profileSettings=" +
      this.profileSettings +
      "systemSettings=" +
      this.systemSettings +
      "userRoles=" +
      this.userRoles +
      "users=" +
      this.users +
      "rateSources=" +
      this.rateSources +
      "currencyPairGroups=" +
      this.currencyPairGroups +
      "environmentTag=" +
      this.environmentTag +
      "tradingChannelProfiles=" +
      this.tradingChannelProfiles +
      "branches=" +
      this.branches +
      "defaultPositionBook=" +
      this.defaultPositionBook +
      "timeZones=" +
      this.timeZones +
      "marketTimeConstants=" +
      this.marketTimeConstants +
      "clientContacts=" +
      this.clientContacts +
      "offlineSystemControls=" +
      this.offlineSystemControls +
      "userVisibilityProfile=" +
      this.userVisibilityProfile +
      "tradableClientCodes=" +
      this.tradableClientCodes +
      "tradableAccountCodes=" +
      this.tradableAccountCodes +
      "algoStrategies=" +
      this.algoStrategies +
      "systemVersion=" +
      this.systemVersion +
      "customFieldDefinitions=" +
      this.customFieldDefinitions +
      "benchmarkFixings=" +
      this.benchmarkFixings +
      "algoHedgeConfigInfos=" +
      this.algoHedgeConfigInfos +
      "tradableBranches=" +
      this.tradableBranches +
      "systemTradeDateRoll=" +
      this.systemTradeDateRoll +
      "requestOrderTypeStrategies=" +
      this.requestOrderTypeStrategies +
      "tradableAlgos=" +
      this.tradableAlgos +
      "autoHedgingStatus=" +
      this.autoHedgingStatus +
      "platformProfiles=" +
      this.platformProfiles +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
